import { z } from 'zod'
import { SuccessEnvelope } from './common.js'

// Per-user notification preferences. `digest_opt_out` suppresses the daily
// campaign digest only — transactional and activity emails always send.
export const NotificationPreferences = z.object({
  digest_opt_out: z.boolean(),
})

// GET /notifications/preferences and PATCH /notifications/preferences both
// return the current preferences in the standard success envelope.
export const NotificationPreferencesResponse = SuccessEnvelope(
  NotificationPreferences,
)
